import type { AllRouteEndpoints } from "../routeTypes";
export const recentlyVisitedVisitCacheKeys: AllRouteEndpoints[] = ["/recently_visited"];
